"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
const getInitialContext = () => ({
  showApptSummary: true,
  onDidBook: undefined,
  providerId: null,
  provider: null,
  locations: null,
  gx: {
    v1: null,
    v2: null,
    v2Conditionals: null,
    /** flag used to check if a call was made to GX API to check for conditionals using relevant and up to date contextualInfo */
    conditionalContextualInfoSent: false
  },
  steps: {},
  curStep: null,
  /**Answers to GX questions that may be reused so a user isn't asked the same question. */
  linkedGxAnswers: {
    /**Reuse(s) that should be visible to the user (e.g., reuse in a form) */
    visible: {},
    /**Reuse(s) that should be hidden from the user (e.g., bypass forms and send directly to the EHR) */
    hidden: {}
  },
  patient: null,
  deepLinkingParams: {},
  apptTimeFilters: {
    timeOfDay: new _set.default(),
    dayOfWeek: new _set.default(),
    selectedLocationIds: new _set.default(),
    jumpedToDate: ''
  },
  /** appointmentQuery is only set later if the purpose has availability */
  appointmentQuery: {},
  selectedAppointment: null,
  csrfToken: null,
  patientRel: null,
  purpose: {},
  locationId: null,
  patientRegistration: {},
  periodStart: null,
  covidUseDefaultStepOrder: false,
  epicOSWConfig: {},
  hideHeader: false,
  services: {
    createAvailabilityUrl: () => {
      throw new Error('createAvailabilityUrl callback not defined');
    },
    createProviderUrl: () => {
      throw new Error('createProviderUrl callback not defined');
    },
    getAltProviders: () => {
      throw new Error('getAltProvidersCallback callback not defined');
    },
    getEhrPatientDemographics: () => {
      throw new Error('getEhrPatientDemographics callback not defined');
    },
    getEhrPatientProxyDemographics: () => {
      throw new Error('getEhrPatientProxyDemographics callback not defined');
    },
    getProviderById: () => {
      throw new Error('getProviderById callback not defined');
    }
  },
  ehrPatientList: [],
  selectedPatientIndex: null,
  updatedFormFields: {},
  dbEnabledProperty: null
});
var _default = exports.default = getInitialContext;